import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const Container = styled('div')<{ theme?: TTheme }>`
    background: ${({ theme }) => theme?.colors.semantic.backgroundSecondary};
    box-shadow: 0 2px 16px 0 rgba(16, 30, 54, 0.06);
    padding: 25px 20px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    .page {
        background-color: ${({ theme }) =>
            theme.colors.semantic.backgroundSecondary};
    }
`

export const Content = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    text-align: center;
    gap: 14px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
`

export const TopText = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors?.greys?.[700]};
    font-size: 22px;
`

export const Headline = styled('div')<{ theme?: TTheme }>`
    font-size: 48px;
    font-weight: 700;
    color: ${({ theme }) => theme?.colors?.greys?.[900]};
`

export const Subheadline = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors?.greys?.[700]};
    font-size: 24px;
`

export const BottomText = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors?.greys?.[800]};
    font-size: 20px;
`

export const Footer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;
`

export const SecondaryButton = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme?.colors?.semantic?.secondaryButtonColor};
    &:hover {
        color: ${({ theme }) =>
            theme?.colors?.semantic?.secondaryButtonHoverColor};
    }
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    svg {
        margin-right: 8px;
        path {
            fill: ${({ theme }) =>
                theme?.colors?.semantic?.secondaryButtonColor};
            transition: fill 0.2s ease-in-out;
        }
    }

    &:hover {
        color: ${({ theme }) =>
            theme?.colors?.semantic?.secondaryButtonHoverColor};
        svg {
            path {
                fill: ${({ theme }) =>
                    theme?.colors?.semantic?.secondaryButtonHoverColor};
            }
        }
    }
`

export const Notice = styled('div')<{ theme?: TTheme }>`
    background: ${({ theme }) =>
        theme.colors.semantic.sendNewInvitationBackground};
    color: ${({ theme }) => theme.colors.greys[800]};
    border-radius: 6px;
    padding: 10px 16px;
    font-size: 15px;
`

export const Description = styled(Typography)<{ theme?: TTheme }>`
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.greys[800]};
`

export const Features = styled('div')`
    display: flex;
    gap: 32px;
    margin-bottom: 18px;
    flex-wrap: wrap;
`

export const FeatureItem = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const VideoBox = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    background: ${({ theme }) =>
        theme.colors.semantic.sendNewInvitationBackground};
    border: 4px solid ${({ theme }) => theme.colors.primary[50]};
    border-radius: 12px;
    width: 240px;
    height: 120px;
    cursor: pointer;
`

export const VideoButton = styled('button')<{ theme?: TTheme }>`
    background: ${({ theme }) =>
        theme.colors.semantic.sendNewInvitationBackground};
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
`

export const VideoText = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.primary[600]};
`

export const ActionsWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
`

export const PlayButtonWrapper = styled('div')<{ theme?: TTheme }>`
    padding: 6px 16px;
`
